import extend from '@/utils/vuex-extend';
import {table} from '@/vuex-extend';
import {fetchList} from '@/api/oms/return-instock';
import {wait} from '@/utils/wait';
import {getAllAdminList} from "@/api/sms/arrival-order";

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {},
		adminList: []
	},
	actions: {
		async getList({state, dispatch}, payload) {
			await wait(dispatch, 'oms.return-instock.list', async function () {
				let {searchForm} = state;
				await dispatch('getData', {
					caller: fetchList,
					options: {
						searchReturnStatus: searchForm.searchReturnStatus,
						returnType: searchForm.returnType,
						expressNo: searchForm.expressNo,
						returnSerialNumber: searchForm.returnSerialNumber,
						skuValue: searchForm.skuValue,
						opAdminId: searchForm.opAdminId,
						...payload
					}
				});
			})
		},
		async getAllAdminList({ state, dispatch, commit }, payload) {
			await wait(dispatch, 'oms.return-instock.all-admin', async function() {
				const response = await getAllAdminList();
				if (response.data) {
					commit('save', {
						adminList: response.data.adminList
					})
				}
			})
		},
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/oms/return-instock/list.js